import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowRight } from "lucide-react";

export default function DiagnosisProCancel() {
  return (
    <main
      className="min-h-screen bg-bg text-ink flex items-center justify-center px-6"
      data-testid="dp-cancel"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="max-w-xl text-center"
      >
        <p className="font-sans text-xs uppercase tracking-mega text-brass">
          Payment cancelled
        </p>
        <h1 className="mt-4 font-serif text-4xl md:text-5xl text-ink italic leading-tight">
          No charge made. No hard feelings.
        </h1>
        <p className="mt-6 font-sans text-base text-ink-muted">
          Whenever you are ready, the door is still open.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/diagnosis-pro"
            data-testid="dp-cancel-retry"
            className="rounded-full bg-forest px-7 py-3.5 font-sans text-xs uppercase tracking-mega text-bg hover:bg-forest-hover transition-colors inline-flex items-center gap-2"
          >
            Try again
            <ArrowRight className="h-4 w-4" />
          </Link>
          <Link
            to="/diagnose"
            data-testid="dp-cancel-back-doors"
            className="font-sans text-xs uppercase tracking-mega text-ink-muted hover:text-forest transition-colors flex items-center gap-2"
          >
            <ArrowLeft className="h-3 w-3" />
            Back to the two doors
          </Link>
        </div>
      </motion.div>
    </main>
  );
}
